<template>
  <a-layout class="callback-container">
    <a-layout-content>
      <div class="result-wrapper">
        <!-- 加载状态 -->
        <template v-if="loading">
          <a-spin
              size="large"
              tip="正在验证登录信息..."
              class="loading-spinner"
          />
        </template>
        <!-- 结果展示 -->
        <template v-else>
          <a-result
              :title="resultTitle"
              :status="resultStatus"
              :sub-title="resultSubTitle"
          >
            <template #extra>
              <a-space>
                <a-button
                    type="primary"
                    @click="handleBackToHome"
                    v-if="showHomeButton"
                >
                  返回首页
                </a-button>
                <a-button
                    type="default"
                    @click="handleBackToLogin"
                    v-if="showRetryButton"
                >
                  返回登录页
                </a-button>
              </a-space>
            </template>
          </a-result>
        </template>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import request from '@/utils/request'
import { setAccessToken } from "@/storage/token";
import { pushLoginFrom } from '@/storage/login_from'

export default defineComponent({
  name: 'ThirdPartyAuthCallback',
  setup() {
    const route = useRoute()
    const router = useRouter()

    // 页面状态
    const loading = ref(true) // 加载状态
    const resultTitle = ref('处理中...')
    const resultStatus = ref('info')
    const resultSubTitle = ref('正在验证第三方登录信息')
    const showHomeButton = ref(false)
    const showRetryButton = ref(false)

    // 处理第三方登录逻辑
    const handleThirdPartyLogin = async () => {
      try {
        loading.value = true
        // 获取路由参数
        const { id } = route.params
        const params = route.query
        console.log(991)
        console.log(params)

        // 调用API验证第三方登录
        const response = await request.get(`/auth/login_3rd_code/${id}`, { params })

        if (response.code === 'success') {
          // 登录成功处理
          resultTitle.value = '登录成功'
          resultStatus.value = 'success'
          resultSubTitle.value = '正在跳转页面...'
          showHomeButton.value = true

          // 保存token
          setAccessToken(response.data.token)

          // 2秒后自动跳转首页
          setTimeout(() => {
            const loginFrom = pushLoginFrom()
            if (loginFrom) {
              window.location.href = decodeURIComponent(loginFrom)
            } else {
              router.push({path: '/'})
            }
          }, 1000)
        } else {
          // API返回的错误
          throw new Error(response.msg || '第三方登录验证失败')
        }
      } catch (error) {
        // 错误处理
        resultTitle.value = '登录失败'
        resultStatus.value = 'error'
        resultSubTitle.value = error.message || '第三方登录验证失败'
        showRetryButton.value = true
        message.error('第三方登录失败: ' + error.message)
      } finally {
        loading.value = false
      }
    }

    // 返回首页
    const handleBackToHome = () => {
      router.push('/')
    }

    // 返回登录页
    const handleBackToLogin = () => {
      router.push('/auth/login')
    }

    // 组件挂载时执行登录逻辑
    onMounted(() => {
      handleThirdPartyLogin()
    })

    return {
      loading,
      resultTitle,
      resultStatus,
      resultSubTitle,
      showHomeButton,
      showRetryButton,
      handleBackToHome,
      handleBackToLogin
    }
  }
})
</script>

<style scoped>
.callback-container {
  min-height: 100vh;
  padding: 20px;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.result-wrapper {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

.loading-spinner {
  margin: 40px 0;
}
</style>
